import { useCallback } from 'react';

// material-ui
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';

// project imports
import IconButton from 'components/@extended/IconButton';
import useConfig from 'hooks/useConfig';
import { ThemeMode } from 'config';

// assets
import SunOutlined from '@ant-design/icons/SunOutlined';
import MoonOutlined from '@ant-design/icons/MoonOutlined';

// ==============================|| HEADER CONTENT - THEME MODE TOGGLE ||============================== //

export default function ThemeModeToggle() {
  const { mode, onChangeMode } = useConfig();
  const isDark = mode === ThemeMode.DARK;

  const handleToggle = useCallback(() => {
    onChangeMode(isDark ? ThemeMode.LIGHT : ThemeMode.DARK);
  }, [isDark, onChangeMode]);

  return (
    <Box sx={{ flexShrink: 0, ml: 0.75 }}>
      <Tooltip title={isDark ? 'Modo claro' : 'Modo escuro'}>
        <IconButton
          color="secondary"
          variant="light"
          sx={(theme) => ({
            color: 'text.primary',
            bgcolor: 'transparent',
            ...theme.applyStyles('dark', { bgcolor: 'transparent' })
          })}
          aria-label="alternar modo de tema"
          onClick={handleToggle}
        >
          {isDark ? <SunOutlined /> : <MoonOutlined />}
        </IconButton>
      </Tooltip>
    </Box>
  );
}
